import { useMemo, useRef } from 'react';

const useMutableRef = <T>(mutable: T) => {
  const reference = useRef(mutable);
  reference.current = mutable;
  return useMemo(() => reference, []);
};

export default useMutableRef;
